export default function isSoftVolume(volumeStats){
    const { maxVolume, softThreshold } = volumeStats
    return maxVolume < softThreshold
}